import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';
import { brandColors } from './tokens/colors';
import { brandSemanticColors } from './semantic-tokens/colors';

const config = defineConfig({
  globalCss: {
    body: {
      // color: 'fg',
      colorPalette: 'brand',
      _dark: {
        fontWeight: 'light',
        fontSize: 'lg',
        color: 'white',
      },
    },
  },
  theme: {
    tokens: {
      fonts: {
        heading: {
          value:
            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        },
        body: {
          value:
            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif, 'Apple Color Emoji','Segoe UI Emoji', 'Segoe UI Symbol'",
        },
        mono: {
          value:
            "'Roboto Mono', SFMono-Regular,Menlo,Monaco,Consolas,'Liberation Mono','Courier New',monospace",
        },
      },
      colors: brandColors,
    },
    semanticTokens: {
      colors: brandSemanticColors,
      radii: {
        l1: { value: '0.375rem' },
        l2: { value: '0.5rem' },
        l3: { value: '0.75rem' },
      },
    },
  },
});

const system = createSystem(defaultConfig, config);

export { system };

{
  /* Semantic Tokens

colors: {
        brand: {
          contrast: {
            value: {
              _light: 'white',
              _dark: 'white',
            },
          },
          fg: {
            value: {
              _light: '{colors.brand.700}',
              _dark: '{colors.brand.300}',
            },
          },
          subtle: {
            value: {
              _light: '{colors.brand.100}',
              _dark: '{colors.brand.900}',
            },
          },
          muted: {
            value: {
              _light: '{colors.brand.200}',
              _dark: '{colors.brand.800}',
            },
          },
          emphasized: {
            value: {
              _light: '{colors.brand.300}',
              _dark: '{colors.brand.700}',
            },
          },
          solid: {
            value: {
              _light: '{colors.brand.500}',
              _dark: '{colors.brand.500}',
            },
          },
          focusRing: {
            value: {
              _light: '{colors.brand.500}',
              _dark: '{colors.brand.500}',
            },
          },
          border: {
            value: {
              _light: '{colors.brand.500}',
              _dark: '{colors.brand.400}',
            },
          },
        },
      },
      */
}
